import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    height: auto;
    width: auto;
    margin-right: 20px;
    margin-top: 20px;
}
`;
